export enum SetupBillingCounterModalType {
    WARNING = 'warning',
    SETUP_INFO = 'info',
}